import { QRCodeSVG } from 'qrcode.react';
import Logo from '@/assets/logo-horizontal.svg';
import { version } from '../../../../package.json';
import { usePageSignIn } from '../hooks';

// Read from across the room: everything is sized in vmin so it scales with the display.
export const PageSignIn = () => {
  const { state } = usePageSignIn();
  const pairPage = state.pairUrl ? displayUrl(state.pairUrl) : null;

  return (
    <div className="flex min-h-screen flex-col bg-muted text-foreground">
      <main className="flex flex-1 items-center justify-center p-[5vmin]">
        <div className="flex w-full max-w-[160vmin] flex-col items-center gap-[6vmin] landscape:flex-row landscape:justify-between">
          <section className="flex flex-col items-center gap-[3.5vmin] text-center landscape:items-start landscape:text-left">
            <img src={Logo} alt="PixelPlay" className="h-[5vmin] w-auto" />

            <h1 className="font-display text-[5.5vmin] font-bold leading-tight tracking-tight">
              Add this screen to PixelPlay
            </h1>

            <ol className="space-y-[1.6vmin] text-[2.6vmin] leading-snug text-muted-foreground">
              <li>
                <span className="font-semibold text-foreground">1.</span> Scan
                the QR code with your phone
                {pairPage && (
                  <>
                    , or open{' '}
                    <span className="font-semibold text-foreground">
                      {pairPage}
                    </span>
                  </>
                )}
              </li>
              <li>
                <span className="font-semibold text-foreground">2.</span> Enter
                this code and choose where the screen lives
              </li>
            </ol>

            <div
              aria-live="polite"
              aria-label={state.code ? `Pairing code ${state.code}` : undefined}
              className="rounded-[2vmin] border border-border bg-background px-[4vmin] py-[2vmin] font-mono text-[11vmin] font-bold leading-none tracking-[0.12em] shadow-lg"
            >
              {state.code ? (
                <>
                  {state.code.slice(0, 3)}
                  <span className="inline-block w-[3vmin]" />
                  {state.code.slice(3)}
                </>
              ) : (
                <span className="text-muted-foreground/40">••• •••</span>
              )}
            </div>

            <p
              className={
                'text-[2.2vmin] ' +
                (state.isOffline ? 'text-destructive' : 'text-muted-foreground')
              }
            >
              {state.isOffline
                ? "Can't reach PixelPlay. Check this screen's internet connection; retrying…"
                : state.code
                  ? 'This screen starts playing as soon as it is added.'
                  : 'Getting a pairing code…'}
            </p>
          </section>

          <section className="shrink-0 rounded-[3vmin] bg-white p-[3vmin] shadow-xl">
            {state.pairUrl ? (
              <QRCodeSVG
                value={state.pairUrl}
                size={512}
                marginSize={0}
                title="Scan to add this screen"
                style={{ width: '36vmin', height: '36vmin', display: 'block' }}
              />
            ) : (
              <div className="h-[36vmin] w-[36vmin] animate-pulse rounded-[1.5vmin] bg-muted" />
            )}
          </section>
        </div>
      </main>

      <footer className="pb-[2.5vmin] text-center text-[1.6vmin] text-muted-foreground">
        v{version}
      </footer>
    </div>
  );
};

// "https://app.pixelplay.live/screen/pair?code=K7M2PQ" → "app.pixelplay.live/screen/pair"
const displayUrl = (pairUrl) => {
  try {
    const url = new URL(pairUrl);
    return url.host + url.pathname;
  } catch {
    return null;
  }
};
